export default __webpack_public_path__ + "static/media/web_login_mobile.872e241d.jpg";